import React from "react";

import GraphqlWrapper from "GraphQL/GraphqlWrapper";
import GridPropsQuery from "../lib/AgGrid/GridPropsQuery";

import Table from "./Table";

const ClientOrderItemsApp = props => {
  return (
    <GraphqlWrapper>
      <GridPropsQuery
        render={({ contractCodes, currentUser }) => (
          <section className="client_section">
            <Table contractCodes={contractCodes} currentUser={currentUser} />
          </section>
        )}
      />
    </GraphqlWrapper>
  );
};

export default ClientOrderItemsApp;
